import { Builder } from '@builder.io/react';
import Image from './image';

Builder.registerComponent(Image, {
  name: 'Image',
  static: true,
  inputs: [
    {
      name: 'image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'gif'],
      required: false,
    },
    {
      name: 'alt',
      type: 'string',
      required: false,
      defaultValue: '',
    },
    {
      name: 'showCaption',
      type: 'boolean',
      required: false,
      defaultValue: false,
      helperText: 'Displays Alt as caption below the image',
    },
    {
      name: 'captionOverride',
      type: 'string',
      required: false,
      advanced: true,
      showIf: (options) => options.get('showCaption'),
    },
    {
      name: 'aspect',
      type: 'boolean',
      advanced: true,
    },
    {
      name: 'aspectWidth',
      type: 'number',
      defaultValue: 1,
      advanced: true,
      showIf: (options) => options.get('aspect'),
    },
    {
      name: 'aspectHeight',
      type: 'number',
      defaultValue: 1,
      advanced: true,
      showIf: (options) => options.get('aspect'),
    },
    {
      name: 'roundedCorners',
      type: 'boolean',
      advanced: false,
    },
    {
      name: 'corner radius',
      type: 'number',
      defaultValue: 20,
      advanced: false,
      showIf: (options) => options.get('roundedCorners'),
    },
  ],
});
